// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"251":"0567abc2","501":"0567abc2","567":"0567abc2"}[chunkId] + ".chunk.css");